module.exports = __webpack_public_path__ + "img/password.e735c5ac.svg";